(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/utils/parse-wagers.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/utils/parse-wagers.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;

function parseWagers() {
  let wagers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  wagers = Array.isArray(wagers) ? wagers : [wagers];
  if (!wagers.length) {
    return {};
  }
  const finishedWagersMap = {};
  wagers.forEach(_ref => {
    let {
      wagerId,
      completedDraws
    } = _ref;
    completedDraws === null || completedDraws === void 0 || completedDraws.forEach(_ref2 => {
      var _finishedWagersMap$ke;
      let {
        productId,
        drawNumber
      } = _ref2;
      const key = "".concat(productMapping.getProductNumericId(productId), "-").concat(drawNumber);
      (_finishedWagersMap$ke = finishedWagersMap[key]) !== null && _finishedWagersMap$ke !== void 0 ? _finishedWagersMap$ke : finishedWagersMap[key] = [];
      if (!finishedWagersMap[key].includes(wagerId)) {
        finishedWagersMap[key].push(wagerId);
      }
    });
  });
  const parsedWagers = {
    activeWager: wagers[0].wagerId,
    finishedWagers: finishedWagersMap
  };
  wagers.forEach(wager => {
    const {
      wagerId,
      betAmount,
      isSubscription,
      properties: {
        channel
      },
      regWagerTime,
      lastDrawDate,
      cancelCloseTime,
      totalDrawCount,
      addonTotalDrawCount,
      completedDraws,
      wins,
      examinedDraws,
      wager: {
        bets
      }
    } = wager;
    const {
      geoLoc,
      geoLocType,
      geoLocName,
      charityId
    } = bets[0].geoBoardData;
    const wagerObj = {
      wagerId,
      betAmount,
      charityId,
      isSubscription,
      channel,
      regWagerTime,
      lastDrawDate,
      cancelCloseTime,
      firstPrimaryDrawNumber: bets.find(b => productMapping.isLyckoplatsenPrimary(b.productId)).drawNum,
      firstSecondaryDrawNumber: bets.find(b => productMapping.isLyckoplatsenSecondary(b.productId)).drawNum,
      totalPrimaryDrawCount: totalDrawCount,
      totalSecondaryDrawCount: addonTotalDrawCount,
      completedDraws: completedDraws.map(draw => {
        const {
          productId,
          drawNumber,
          time
        } = draw;
        const drawWin = wins.find(win => win.productId.toLowerCase() === productId.toLowerCase() && win.drawNumber === drawNumber);
        const examined = examinedDraws.some(examined => examined.productId === productId && examined.drawNumber === drawNumber);
        return _objectSpread({
          productId,
          drawNumber,
          time,
          examined
        }, drawWin && {
          win: {
            payoutTime: drawWin.payoutTime,
            payoutDone: drawWin.payoutDone,
            payoutTarget: drawWin.payoutTarget,
            amount: drawWin.amount,
            winDiv: drawWin.winDiv
          }
        });
      }),
      location: {
        latitude: geoLoc.latitude,
        longitude: geoLoc.longitude,
        name: geoLocName,
        type: geoLocType
      }
    };
    parsedWagers[wagerId] = wagerObj;
  });
  return parsedWagers;
}
if (svs.isServer) {
  module.exports = parseWagers;
} else {
  setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.utils', {
    parseWagers
  });
}

 })(window);